import React, { PureComponent, Component, ChangeEvent } from 'react'

import Dialog from '@material-ui/core/Dialog'
import TextField from '@material-ui/core/TextField'

import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import { CirclePicker } from 'react-color';
import SelectList from '../SelectList'
import { Trade } from '../../models/Trade';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
const _ = require('lodash')

export interface Props {
    isTradeDialogOpen: boolean;
    tradeToEdit: Trade;
    tradeToEditId?: string;
    closeTradeDialogValue: () => void;
    submitTradeValue: (trade:Trade, tradeToEditId?:string) => Promise<void>
    errorAlert: (error:string) => Promise<void>;
    projectUsers: Record<string, any>
    classes: ClassNameMap;
}

type State = {
    tradeId: string | null;
    trade: Trade;
}

class TradeDialog extends Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
            tradeId: null,
            trade: {
                name: null,
                color: '#000',
                users: {}
            }
        }
    }

    componentDidMount() {
        const {
            tradeToEdit,
            tradeToEditId
          } = this.props;
      
        if(!!tradeToEdit) {
            this.state = {
                tradeId: tradeToEditId,
                trade: {
                    name: tradeToEdit.name,
                    color: tradeToEdit.color,
                    users: !!tradeToEdit.users ? tradeToEdit.users : {}
                }
            }   
        }
    }

    shouldComponentUpdate(nextProps:Props, nextState:State) {
        

        if ( !nextProps.tradeToEditId && !!this.props.tradeToEdit) {
            nextState.trade = {
                name: null,
                color: '#000',
                users: {}
            }


            return true
        }

        if(!!nextProps.tradeToEdit && !_.isEqual(nextProps.tradeToEditId,this.props.tradeToEditId)) {
            nextState.trade = nextProps.tradeToEdit

            if(!nextState.trade.users) {
                nextState.trade.users = {}
            }

            return true
        }
    
        
    
        if(!_.isEqual(nextState.trade, this.state.trade)) {

            return true
        }

        if(this .props.isTradeDialogOpen !== nextProps.isTradeDialogOpen) {
            nextState.trade = {
                name: null,
                color: '#000',
                users: {}
            }
            return true
        }

        return false
    }

    async closeDialog() {
        const { closeTradeDialogValue } = this.props
        closeTradeDialogValue()
    }

    async onUsersChange(value: any[] | null) {
        const trade = { ...this.state.trade }

        const newValue = !!value ? value : []

       
        const userIds = newValue.map(item => item.value)
        const userMap = userIds.reduce((obj, item) => {
            obj[item] = true
            return obj
        }, {})
    
        trade.users = userMap
    
        this.setState({
            trade
        })
    }

    async onColorChange(value:any) {
        const trade = { ...this.state.trade }
        trade.color = value.hex
    
        this.setState({
            trade
        })
    }

    async onNameChange(event: any) {
        const trade = { ...this.state.trade }
        
        trade.name = event.target.value

        this.setState({
            trade
        });
    }

    async onSubmit() {
        const { trade } = this.state
        const { submitTradeValue, tradeToEditId, errorAlert } = this.props

        if(!trade.color || !trade.name || !trade.users) {
            errorAlert('Fill Required Fields')

            return
        }
        submitTradeValue(trade, tradeToEditId)
        this.closeDialog()
    }

    render() {
        const { trade } = this.state
        const { isTradeDialogOpen, classes } = this.props;
        return (
          <Dialog
            maxWidth='sm'
            fullWidth={true}
            open={!!isTradeDialogOpen}
            onBackdropClick={this.closeDialog.bind(this)}
          >
              <DialogContent>
                <div style={{backgroundColor: trade.color}} className={classes.DialogFormTitle}>
                    <p className={classes.DialogFormTitleText}>
                        Create Trade
                    </p>
                </div>
                <div className={classes.DialogFormContent} >
                    <div className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Trade*</p>
                        <TextField
                            required={true}
                            defaultValue={!!trade.name ? trade.name : ""}
                            onChange={this.onNameChange.bind(this)}
                            fullWidth={true}
                        />
                    </div>
                    <CirclePicker 
                        color={ trade.color }
                        onChangeComplete={ this.onColorChange.bind(this) } />
                    <div style={{alignItems: 'flex-start', minHeight: 150}} className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Users</p>
                        <SelectList
                            style={{width: '100%', margin: '0'}}
                            title=''
                            onChange={this.onUsersChange.bind(this)}
                            optionList={this.props.projectUsers}
                            value={trade.users} 
                        />
                    </div>
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.closeDialog.bind(this)} color="secondary"> Cancel </Button>
                <Button onClick={this.onSubmit.bind(this)} color="primary"> Confirm </Button>
              </DialogActions>
          </Dialog>
        )
    }
    
}


export default TradeDialog
  


// WEBPACK FOOTER //
// ./src/components/Dialogs/TradeDialog.tsx